import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Drawer,
  Select,
  message,
  TreeSelect,
  Radio,
} from "antd";
import { withRouter } from "react-router-dom";
import { validate as isValidEmail } from "email-validator";
import api from "../../../services/api";
import { getTreeData } from "../../../services/utils";
import { useFreire } from "../../../utils/freireContext";
import * as texts from "../locales";

const EditDrawer = ({ form, onSave, visible, onClose, loading, group }) => {
  const [loadingStations, setLoadingStations] = useState(false);
  const [stations, setStations] = useState([]);
  const { freire } = useFreire();
  const [mode, setMode] = useState(group.searchBy || "station");
  const [companies, setCompanies] = useState([]);
  const [companyID, setCompanyID] = useState(group.companyID);

  const getCompanies = async () => {
    const { data } = await api.get("company");
    setCompanies(data);
  };

  async function getStations() {
    try {
      setLoadingStations(true);
      setStations([]);

      const { data } = await api.get(`select/connected_stations`, {
        disabled: false,
        test: false,
        centralSystem: true,
      });

      setLoadingStations(false);
      setStations(data);
    } catch (error) {
      message.error(freire(texts.ERROR_GET_STATIONS));
      setLoadingStations(false);
    }
  }

  function save() {
    form.validateFields(async (err, payload) => {
      if (err) {
        return;
      }
      const data = {
        ...payload,
        searchBy: payload.searchBy || mode,
      };
      if (mode === "company") {
        data.companyID = companyID;
      }
      onSave(data);
    });
  }

  useEffect(() => {
    if (visible) {
      setStations([]);
      form.setFieldsValue({
        ...group,
        phones: group.phones.map((phone) => phone.replace(/^\+55/, "")),
        searchBy: group.searchBy || "station",
      });
      setMode(group.searchBy || "station");
      setCompanyID(group.companyID);
    }
    if (mode === "company" && companies.length === 0) {
      getCompanies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    if (mode === "company" && companies.length === 0) {
      getCompanies();
    } else {
      form.setFieldsValue({
        stations: group.stations,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  return (
    <Drawer
      title={freire(texts.EDIT_GROUP)}
      width={"40%"}
      onClose={() => (loading ? {} : onClose())}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={freire(texts.GROUP_NAME)}>
              {form.getFieldDecorator("name", {
                rules: [
                  {
                    required: true,
                    message: freire(texts.REQUIRED_FIELD),
                  },
                ],
              })(
                <Input
                  disabled={loading}
                  placeholder={freire(texts.GROUP_NAME_EX)}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={freire(texts.EMAIL_LIST)}>
              {form.getFieldDecorator("emails", {
                rules: [
                  {
                    required: true,
                    message: freire(texts.REQUIRED_FIELD),
                  },
                ],
              })(
                <Select
                  mode="tags"
                  disabled={loading}
                  style={{ width: "100%" }}
                  placeholder={freire(texts.INPUT_EMAILS)}
                  onSelect={(value) => {
                    if (!isValidEmail(value)) {
                      message.warning(freire(texts.INFORM_VALID_EMAIL));
                      const emails = form.getFieldValue("emails");

                      const index = emails.indexOf(value);
                      if (index > -1) {
                        emails.splice(index, 1);
                        form.setFieldsValue({ emails });
                      }
                    }
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={freire(texts.PHONES_LIST)}>
              {form.getFieldDecorator("phones", {
                // rules: [
                //   {
                //     required: true,
                //     message: freire(texts.REQUIRED_FIELD),
                //   },
                // ],
              })(
                <Select
                  mode="tags"
                  disabled={loading}
                  style={{ width: "100%" }}
                  placeholder={freire(texts.INPUT_PHONES)}
                  onSelect={(value) => {
                    const isValid = (value) => value.length > 0;
                    if (!isValid(value)) {
                      message.warning(freire(texts.IINFORM_VALID_PHONE));
                      const phones = form.getFieldValue("phones");

                      const index = phones.indexOf(value);
                      if (index > -1) {
                        phones.splice(index, 1);
                        form.setFieldsValue({ phones });
                      }
                    }
                  }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={freire(texts.LIST_BY)}>
              {form.getFieldDecorator("searchBy", {
                initialValue: group.searchBy || "station",
              })(
                <Radio.Group
                  value={mode}
                  onChange={e => {
                    setMode(e.target.value);
                    form.setFieldsValue({ searchBy: e.target.value });
                  }}
                  disabled={loading}
                >
                  <Radio value="company">{freire(texts.COMPANY)}</Radio>
                  <Radio value="station">{freire(texts.STATION)}</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        {mode === "station" && (
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={freire(texts.STATIONS)}>
                {form.getFieldDecorator("stations", {
                  rules: [
                    {
                      required: true,
                      message: freire(texts.REQUIRED_FIELD),
                    },
                  ],
                })(
                  <TreeSelect
                    multiple
                    treeCheckable
                    treeNodeFilterProp="title"
                    showCheckedStrategy={TreeSelect.SHOW_CHILD}
                    disabled={loading || loadingStations}
                    searchPlaceholder={freire(texts.SELECT_STATIONS)}
                    dropdownStyle={{ maxHeight: 220 }}
                    treeData={getTreeData({
                      title: freire(texts.SELECT_ALL(stations.length)),
                      loading: loadingStations,
                      children: stations.map((station) => ({
                        title: `${station.name} (${station.stationID})`,
                        key: station._id,
                        value: station.stationID,
                      })),
                    })}
                    onDropdownVisibleChange={(opened) => {
                      if (opened && stations.length === 0) {
                        getStations();
                      }
                    }}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        )}
        {mode === "company" && (
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={freire(texts.COMPANY)}>
                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Selecione a empresa"
                  value={companyID}
                  onChange={setCompanyID}
                  disabled={loading}
                >
                  {companies.map((company) => (
                    <Select.Option key={company._id} value={company._id}>
                      {company.companyName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <div style={{ color: '#888', fontSize: 12, marginTop: -8, marginBottom: 16 }}>
                {freire(texts.COMPANY_ALERT_OBS)}
              </div>
            </Col>
          </Row>
        )}
      </Form>
      <div
        style={{
          position: "absolute",
          right: 0,
          bottom: 0,
          width: "100%",
          borderTop: "1px solid #e9e9e9",
          padding: "10px 16px",
          background: "#fff",
          textAlign: "right",
        }}
      >
        <Button
          disabled={loading}
          onClick={() => onClose()}
          style={{ marginRight: 8 }}
        >
          {freire(texts.CANCEL)}
        </Button>
        <Button loading={loading} onClick={() => save()} type="primary">
          {freire(texts.SAVE)}
        </Button>
      </div>
    </Drawer>
  );
};

const ComponentEditDrawer = Form.create({ name: "edit" })(EditDrawer);
export default withRouter(ComponentEditDrawer);
